import type { ButtonHTMLAttributes, ReactNode } from 'react'
import css from './Button.module.css'
import { Icon, type IconName } from './Icon'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'dangerGhost'
type Size = 'sm' | 'md' | 'lg'

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  variant?: Variant
  size?: Size
  icon?: IconName
  iconAfter?: IconName
  /** Menampilkan pemintal dan menonaktifkan tombol tanpa mengubah lebarnya. */
  loading?: boolean
  full?: boolean
  children?: ReactNode
}

export function Button({
  variant = 'secondary',
  size = 'md',
  icon,
  iconAfter,
  loading = false,
  full = false,
  children,
  className,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  const iconOnly = !children && (icon !== undefined || iconAfter !== undefined)
  const iconSize = size === 'sm' ? 16 : size === 'lg' ? 20 : 18

  const classes = [
    css.base,
    css[size],
    css[variant],
    iconOnly ? css.iconOnly : '',
    full ? css.full : '',
    loading ? css.loading : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      {children && <span className={css.label}>{children}</span>}
      {iconAfter && <Icon name={iconAfter} size={iconSize} />}
      {loading && (
        <span className={css.spinner} aria-hidden="true">
          <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2.5" />
            <path
              d="M21 12a9 9 0 0 0-9-9"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </span>
      )}
    </button>
  )
}
